import { render, staticRenderFns } from "./Demo2.vue?vue&type=template&id=4b57ea02&"
import script from "./Demo2.vue?vue&type=script&lang=js&"
export * from "./Demo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports